import ColonyAddAnimals from '@/components/Colony/Edit/AddAnimals';

export default ColonyAddAnimals;
